<template>
  <v-container fluid v-scroll:#lin-profile-mockup="onScroll" class="overflow-x-hidden elevation-6">
    <div v-for="(section, sectionName) in scrapedProfile" :key="sectionName" v-if="section && sectionsToHide.indexOf(sectionName) < 0">
      <v-row :id="sectionName + 'Mockup'" v-if="(section || delta[sectionName]) && sectionName !== 'scrapedDate'">
        <v-col cols="12" :md="6" :lg="6">
          <summary-mocker :summary="scrapedProfile.summary" :delta-section="delta.summary" v-if="scrapedProfile.summary && sectionName ==='summary'"></summary-mocker>
          <activities-mocker :activities="scrapedProfile.activities" :delta-section="delta.activities" v-if="scrapedProfile.activities && sectionName ==='activities'"></activities-mocker>
          <jobs-mocker :jobs="scrapedProfile.jobs" :delta-section="delta.jobs" v-if="scrapedProfile.jobs && sectionName ==='jobs'"></jobs-mocker>
          <education-mocker :education="scrapedProfile.education" :delta-section="delta.education" v-if="scrapedProfile.education && sectionName === 'education'"></education-mocker>
          <certifications-mocker :certifications="scrapedProfile.certifications" :delta-section="delta.certifications" v-if="scrapedProfile.certifications && sectionName === 'certifications'"></certifications-mocker>
          <publications-mocker :publications="scrapedProfile.publications" :delta-section="delta.publications" v-if="scrapedProfile.publications && sectionName === 'publications'"></publications-mocker>
          <languages-mocker :languages="scrapedProfile.languages" :delta-section="delta.languages" v-if="scrapedProfile.languages && sectionName === 'languages'"></languages-mocker>
          <volunteering-mocker :volunteering="scrapedProfile.volunteering" :delta-section="delta.volunteering" v-if="scrapedProfile.volunteering && sectionName === 'volunteering'"></volunteering-mocker>
          <projects-mocker :projects="scrapedProfile.projects" :delta-section="delta.projects" v-if="scrapedProfile.projects && sectionName === 'projects'"></projects-mocker>
          <awards-mocker :awards="scrapedProfile.awards" :delta-section="delta.awards" v-if="scrapedProfile.awards && sectionName === 'awards'"></awards-mocker>
          <groups-mocker :groups="scrapedProfile.groups" :delta-section="delta.groups" v-if="scrapedProfile.groups && sectionName === 'groups'"></groups-mocker>
          <organizations-mocker :organizations="scrapedProfile.organizations" :delta-section="delta.organizations" v-if="scrapedProfile.organizations && sectionName === 'organizations'"></organizations-mocker>
          <recommendations-mocker :recommendations="scrapedProfile.recommendations" :delta-section="delta.recommendations" v-if="scrapedProfile.recommendations && sectionName === 'recommendations'"></recommendations-mocker>
          <patents-mocker :patents="scrapedProfile.patents" :delta-section="delta.patents" v-if="scrapedProfile.patents && sectionName === 'patents'"></patents-mocker>
          <scores-mocker :scores="scrapedProfile.scores" :delta-section="delta.scores" v-if="scrapedProfile.scores && sectionName === 'scores'"></scores-mocker>
          <courses-mocker :courses="scrapedProfile.courses" :delta-section="delta.courses" v-if="scrapedProfile.courses && sectionName === 'courses'"></courses-mocker>
        </v-col>
        <v-col cols="12" :md="6" :lg="6">
          <v-expansion-panels :value="expanded" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="white--text" :class="'section-'+sectionName">{{sectionName}} - {{getNumberOfChangesInSection(delta[sectionName])}} items changed</v-expansion-panel-header>
              <v-expansion-panel-content v-html="subPartFormatted(delta[sectionName])" class="custom-content-diff grey lighten-4" v-if="delta[sectionName]"></v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </div>
  </v-container>
</template>

<script>
  import SummaryMocker from "./Lin/summaryMocker";
  import {getNumberOfChangesInSection} from "../../helpers/helpers";
  import {formatters} from "jsondiffpatch";
  import ActivitiesMocker from "./Lin/activitiesMocker";
  import JobsMocker from "./Lin/jobsMocker";
  import EducationMocker from "./Lin/educationMocker";
  import CertificationsMocker from "./Lin/certificationsMocker";
  import PublicationsMocker from "./Lin/publicationsMocker";
  import LanguagesMocker from "./Lin/languagesMocker";
  import VolunteeringMocker from "./Lin/volunteeringMocker";
  import ProjectsMocker from "./Lin/projectsMocker";
  import AwardsMocker from "./Lin/awardsMocker";
  import GroupsMocker from "./Lin/groupsMocker";
  import RecommendationsMocker from "./Lin/recommendationsMocker";
  import PatentsMocker from "./Lin/patentsMocker";
  import ScoresMocker from "./Lin/scoresMocker";
  import CoursesMocker from "./Lin/coursesMocker";
  import OrganizationsMocker from "./Lin/organizationsMocker";

  const sectionsToHide = [
    'scrapedDate',
    'otherPeopleSameName',
    'profileLanguages',
    'proposedCourses',
    'peopleAlsoViewed',
    'similarProfiles'
  ];

  export default {
    name: "linProfileMockup",
    components: {
      OrganizationsMocker,
      CoursesMocker,
      ScoresMocker,
      PatentsMocker,
      RecommendationsMocker,
      GroupsMocker,
      AwardsMocker,
      ProjectsMocker,
      VolunteeringMocker,
      LanguagesMocker,
      PublicationsMocker, CertificationsMocker, EducationMocker, JobsMocker, ActivitiesMocker, SummaryMocker},
    props: ['scrapedProfile', 'delta'],
    data(){
      return {
        expanded: [0],
        offsetTop: 0,
        sectionsToHide
      }
    },
    methods: {
      getNumberOfChangesInSection(item){
        return getNumberOfChangesInSection(item);
      },
      subPartFormatted(item) {
        let formatted = formatters.html.format(item, this.scrapedProfile);
        formatters.html.hideUnchanged();
        return formatted;
      },
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mockers/linProfileMockup.vue